import { render } from "./Prijava.vue?vue&type=template&id=ef5e48a2&scoped=true"
import script from "./Prijava.vue?vue&type=script&lang=js"
export * from "./Prijava.vue?vue&type=script&lang=js"

import "./Prijava.vue?vue&type=style&index=0&id=ef5e48a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5e48a2"]])

export default __exports__